module.exports = __webpack_public_path__ + "media/images/proof_links/disneyplus-508bd846ed7d53cdaca2d602157c6ec1.svg";